import { useNavigate, useParams } from "react-router";

import { IconButton, TableDataCell, useDialog } from "@digital-services/ui";

import { manageAppRolesRoute } from "@api-users/common";

import EditIcon from "@icons/edit.svg?react";
import TrashIcon from "@icons/trash.svg?react";
import { formatterShort } from "@utils/time-utils";

import { AppRoleItem } from "../../models/app-roles-models";

interface Props {
  data: AppRoleItem;
}

export const AppRoleDataRow = (props: Props) => {
  const { data } = props;

  const navigate = useNavigate();
  const { showDialog } = useDialog();
  const { apiUserId } = useParams();

  const onDeleteAppRoleRecord = () => {
    showDialog({
      variant: "error",
      header: `Delete Application role?`,
      content: "",
      confirmButton: "Delete",
      confirmButtonVariant: "ghost",
      onConfirm: () => {
        // TBD
      },
      cancelButton: "Cancel",
      cancelButtonVariant: "discreet",
      onCancel: () => {
        /* Do nothing */
      }
    });
  };

  return (
    <tr className="leading-[0px]">
      <TableDataCell>{formatterShort(data.addedAt)}</TableDataCell>
      <TableDataCell>{data.application}</TableDataCell>
      <TableDataCell>{data.roles?.join(", ")}</TableDataCell>

      <TableDataCell className="py-0!">
        <div className="flex">
          <IconButton
            onClick={() => {
              navigate(manageAppRolesRoute(apiUserId!));
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => onDeleteAppRoleRecord}>
            <TrashIcon />
          </IconButton>
        </div>
      </TableDataCell>
    </tr>
  );
};
